export const GET_WS = 'GET_WS';
export const GET_WS_SUCCESS = 'GET_WS_SUCCESS';
export const GET_WS_ERROR = 'GET_WS_ERROR';
